import { GraphNode } from '../graph-node.js';
const LOOP_EXEC_OUT_PORT_KEYS = new Set(['exec', 'done']);
function normalizeIterationCount(value) {
    const count = Number(value);
    if (!Number.isFinite(count))
        return 0;
    return Math.max(0, Math.floor(count));
}
export class LoopNode extends GraphNode {
    isExecOutPort(outPortKey) {
        if (LOOP_EXEC_OUT_PORT_KEYS.has(outPortKey))
            return true;
        return super.isExecOutPort(outPortKey);
    }
    async run() {
        super.run();
        const iterationCount = normalizeIterationCount(this.data.count);
        for (let index = 0; index < iterationCount; index += 1) {
            this.data.index = index;
            await this.runOutPort('exec');
        }
        await this.runOutPort('done');
    }
}
